<div class="dialog-container px-6 pt-6" style="padding-bottom: 0.65rem">
  <div class="dialog-header">
    @if (!data.imageSrc) { @if(data?.materialIconColor){
    <div class="material-icon-wrapper" [ngClass]="data?.materialIconColor">
      <span class="material-icons">{{ data.materialIcon }}</span>
    </div>
    }@else{
    <div class="material-icon-wrapper" [ngClass]="data?.isRedBg ? '' : data?.blueBg ? 'bg-k-blue' : data.materialIcon">
      <span class="material-icons" *ngIf="data?.materialIcon != 'trash'">{{ data.materialIcon == 'remove-info' ? 'close' : data.materialIcon }}</span>
      <span *ngIf="data?.materialIcon == 'trash'"><img src="/assets/images/trash-white.svg" /></span>
    </div>
    } } @if (data.imageSrc) {
    <div class="material-icon-wrapper" [ngClass]="data.materialIcon">
      @if (data.imageSrc == '../../../../assets/images/attachment.svg') {
      <img [src]="data.imageSrc" style="height: 14px" />
      } @if (data.imageSrc != '../../../../assets/images/attachment.svg') {
      <img [src]="data.imageSrc" style="height: 22px" />
      }
    </div>
    }
    <h3 class="title-header">{{ data.title }}</h3>
  </div>

  <mat-dialog-content class="p-0">
    <div class="pb-4 text-sm font-medium">
      @if(data?.networkRemoveText) {
      <div [innerHTML]="data.networkRemoveText"></div>
      }@if(data?.discoveryText) {
      <div [innerHTML]="data.discoveryText"></div>
      }@if(data?.htmlText) {
      <div [innerHTML]="data.htmlText"></div>
      }@else {
      <p
        [ngClass]="{ 'm-0 text-[#18191C] text-sm font-medium' : !!data.checkBoxTitle || !!data.darkText,

        }"
      >
        {{ data.text }}
      </p>
      } @if (data.subText) {
      <p>
        You have assigned all 10 of your premium user licenses, please
        <a href="https://help.kinnect.us/" target="_blank" style="color: #25508e; text-decoration: underline">reach out</a> to us if you need more.
      </p>
      } @if (!!data.checkBoxTitle) {
      <p class="app__confirm--checkbox">
        <mat-checkbox type="checkbox" class="flex items-center h-full fa-delete-all-checkbox" [(ngModel)]="checked" (change)="selectOne($event)">
          {{ data.checkBoxTitle }}
        </mat-checkbox>
      </p>
      } @if (!!data?.entityFiles && !!data?.entityFiles?.length && data?.entityFiles?.length > 0) {

      <div class="flex flex-col gap-2 h-[100px] overflow-y-auto">
        @for (file of data.entityFiles; track file.id) {
        <div class="app__confirm--checkbox m-0">
          <mat-checkbox type="checkbox" class="flex items-center h-full fa-delete-all-checkbox" (change)="selectOneEntityFile($event, file)">
            Also delete the vault <span class="font-bold">{{ file?.vault_name }}</span>
          </mat-checkbox>
        </div>
        }
      </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="p-0">
    <div class="dialog-actions">
      @if (hasThirdButton) {
      <button
        type="button"
        class="white-bg-btn font-bold"
        (click)="closeDialog(true)"
        [ngClass]="data?.hideCancel ? 'd-none' : ''"
        [ngClass]="data?.backButtonBold ? 'font-bold' : ''"
      >
        {{ data?.thirdButtonTitle ? data?.thirdButtonTitle : 'Cancel' }}
      </button>
      } @if (showCancelBtn || (data.materialIcon !== 'info' && data.materialIcon !== 'error' && !data.isRedBg && !hideCancel)) {
      <button
        type="button"
        class="white-bg-btn"
        style="margin-left: 10px"
        (click)="closeDialog()"
        [ngClass]="data?.hideCancel ? 'd-none' : ''"
        [ngClass]="data?.backButtonBold ? 'font-bold' : ''"
      >
        {{ data?.backBUttonTitle ? data?.backBUttonTitle : data.proceedTitle ? 'Cancel' : 'Okay' }}
      </button>
      } @if (data.proceedTitle) {
      <button
        style="margin-left: 12px !important"
        mat-button
        [ngClass]="data?.isRedBg ? '' : data?.blueBg ? 'bg-k-blue' : data?.materialIconColor ? data?.materialIconColor : data.materialIcon"
        type="button"
        class="submit"
        (click)="confirmDialog()"
      >
        {{ data.proceedTitle }}
      </button>
      }
    </div>
  </mat-dialog-actions>
</div>
